import { YesNoRadioButtons } from 'components/shared/ButtonsGroup/YesNoRadioButtons';
import { FC, useCallback } from 'react';
import type { TradeWay } from 'state/secondaryMarket/secondaryMarket.model';

type Props = {
  value: TradeWay;
  onTradeWayChange: (s: TradeWay) => void;
  canEditTradeWay: boolean;
};
export const TradeWayField: FC<Props> = ({ value, onTradeWayChange, canEditTradeWay }) => {
  const onYesNoChange = useCallback(
    (value: boolean) => {
      const way: TradeWay = value ? 'ClientBuy' : 'ClientSell';
      onTradeWayChange(way);
    },
    [onTradeWayChange],
  );
  return (
    <YesNoRadioButtons
      className="w-100"
      id="tradeWay"
      e2e="tradeWay"
      value={value === 'ClientBuy'}
      onSelect={onYesNoChange}
      isDisabled={!canEditTradeWay}
      translationPrefix="secondaryMarket.tradeInformation.tradeWay"
    />
  );
};
